var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h-dialog',_vm._g(_vm._b({attrs:{"error":""}},'h-dialog',_vm.$attrs,false),_vm.$listeners),[_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }